function BrandCategoriesCombinationListSkeleton() {
  return <div className='mt-4 h-7 w-full lg:mt-6' data-sentry-component="BrandCategoriesCombinationListSkeleton" data-sentry-source-file="brand-categories-combination-list-skeleton.tsx">
            <div className='h-full w-full animate-pulse rounded bg-gray-100' />
        </div>;
}
export default BrandCategoriesCombinationListSkeleton;